import {
  Formdata as Data,
  FormdataCollection as Collection,
} from '@/typings/api/Formdata'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class FormdataApi extends BaseApiAuth<Data, Collection> {
    protected readonly endpoint = 'data-collection/form-data';
}
